var map = {
	"./messaging-center/messaging-center.module": [
		"./src/app/employee-layout/employees/messaging-center/messaging-center.module.ts",
		"messaging-center-messaging-center-module"
	],
	"src/app/employee-layout/employees/attendance/attendance.module": [
		"./src/app/employee-layout/employees/attendance/attendance.module.ts",
		"src-app-employee-layout-employees-attendance-attendance-module"
	],
	"src/app/employee-layout/employees/canteen/canteen.module": [
		"./src/app/employee-layout/employees/canteen/canteen.module.ts",
		"default~src-app-employee-layout-employees-canteen-canteen-module~src-app-employee-layout-employees-e~50efbfbb",
		"default~src-app-employee-layout-employees-canteen-canteen-module~src-app-employee-layout-employees-e~7fba699d",
		"common",
		"src-app-employee-layout-employees-canteen-canteen-module"
	],
	"src/app/employee-layout/employees/examination/examination.module": [
		"./src/app/employee-layout/employees/examination/examination.module.ts",
		"default~src-app-employee-layout-employees-canteen-canteen-module~src-app-employee-layout-employees-e~50efbfbb",
		"common",
		"src-app-employee-layout-employees-examination-examination-module"
	],
	"src/app/employee-layout/employees/examination/mock-examinations/mock-examinations.module": [
		"./src/app/employee-layout/employees/examination/mock-examinations/mock-examinations.module.ts",
		"default~src-app-employee-layout-employees-canteen-canteen-module~src-app-employee-layout-employees-e~50efbfbb",
		"common",
		"src-app-employee-layout-employees-examination-mock-examinations-mock-examinations-module"
	],
	"src/app/employee-layout/employees/examination/reports/reports.module": [
		"./src/app/employee-layout/employees/examination/reports/reports.module.ts",
		"common",
		"src-app-employee-layout-employees-examination-reports-reports-module"
	],
	"src/app/employee-layout/employees/extra-bill/extra-bill.module": [
		"./src/app/employee-layout/employees/extra-bill/extra-bill.module.ts",
		"default~src-app-employee-layout-employees-canteen-canteen-module~src-app-employee-layout-employees-e~50efbfbb",
		"default~src-app-employee-layout-employees-canteen-canteen-module~src-app-employee-layout-employees-e~7fba699d",
		"common",
		"src-app-employee-layout-employees-extra-bill-extra-bill-module"
	],
	"src/app/employee-layout/employees/finances/daily-collections/daily-collections.module": [
		"./src/app/employee-layout/employees/finances/daily-collections/daily-collections.module.ts",
		"src-app-employee-layout-employees-finances-daily-collections-daily-collections-module"
	],
	"src/app/employee-layout/employees/finances/expenses/expense.module": [
		"./src/app/employee-layout/employees/finances/expenses/expense.module.ts",
		"default~src-app-employee-layout-employees-canteen-canteen-module~src-app-employee-layout-employees-e~50efbfbb",
		"common",
		"src-app-employee-layout-employees-finances-expenses-expense-module"
	],
	"src/app/employee-layout/employees/finances/finance-reports/finance-reports.module": [
		"./src/app/employee-layout/employees/finances/finance-reports/finance-reports.module.ts",
		"common",
		"src-app-employee-layout-employees-finances-finance-reports-finance-reports-module"
	],
	"src/app/employee-layout/employees/finances/finance-settings/finance-settings.module": [
		"./src/app/employee-layout/employees/finances/finance-settings/finance-settings.module.ts",
		"src-app-employee-layout-employees-finances-finance-settings-finance-settings-module"
	],
	"src/app/employee-layout/employees/finances/finances.module": [
		"./src/app/employee-layout/employees/finances/finances.module.ts",
		"src-app-employee-layout-employees-finances-finances-module"
	],
	"src/app/employee-layout/employees/finances/incomes/incomes.module": [
		"./src/app/employee-layout/employees/finances/incomes/incomes.module.ts",
		"default~src-app-employee-layout-employees-canteen-canteen-module~src-app-employee-layout-employees-e~50efbfbb",
		"common",
		"src-app-employee-layout-employees-finances-incomes-incomes-module"
	],
	"src/app/employee-layout/employees/finances/online-payment/online-payment.module": [
		"./src/app/employee-layout/employees/finances/online-payment/online-payment.module.ts",
		"src-app-employee-layout-employees-finances-online-payment-online-payment-module"
	],
	"src/app/employee-layout/employees/finances/student-bills/student-bills.module": [
		"./src/app/employee-layout/employees/finances/student-bills/student-bills.module.ts",
		"default~src-app-employee-layout-employees-canteen-canteen-module~src-app-employee-layout-employees-e~50efbfbb",
		"default~src-app-employee-layout-employees-canteen-canteen-module~src-app-employee-layout-employees-e~7fba699d",
		"common",
		"src-app-employee-layout-employees-finances-student-bills-student-bills-module"
	],
	"src/app/employee-layout/employees/finances/student-finance-archive/student-finance-archive.module": [
		"./src/app/employee-layout/employees/finances/student-finance-archive/student-finance-archive.module.ts",
		"default~src-app-employee-layout-employees-canteen-canteen-module~src-app-employee-layout-employees-e~50efbfbb",
		"default~src-app-employee-layout-employees-canteen-canteen-module~src-app-employee-layout-employees-e~7fba699d",
		"common",
		"src-app-employee-layout-employees-finances-student-finance-archive-student-finance-archive-module"
	],
	"src/app/employee-layout/employees/general-settings/general-settings.module": [
		"./src/app/employee-layout/employees/general-settings/general-settings.module.ts",
		"default~src-app-employee-layout-employees-canteen-canteen-module~src-app-employee-layout-employees-e~50efbfbb",
		"common",
		"src-app-employee-layout-employees-general-settings-general-settings-module"
	],
	"src/app/employee-layout/employees/human-resource/human-resource.module": [
		"./src/app/employee-layout/employees/human-resource/human-resource.module.ts",
		"default~src-app-employee-layout-employees-canteen-canteen-module~src-app-employee-layout-employees-e~50efbfbb",
		"common",
		"src-app-employee-layout-employees-human-resource-human-resource-module"
	],
	"src/app/employee-layout/employees/independent-bill/independent-bill.module": [
		"./src/app/employee-layout/employees/independent-bill/independent-bill.module.ts",
		"default~src-app-employee-layout-employees-canteen-canteen-module~src-app-employee-layout-employees-e~50efbfbb",
		"default~src-app-employee-layout-employees-canteen-canteen-module~src-app-employee-layout-employees-e~7fba699d",
		"common",
		"src-app-employee-layout-employees-independent-bill-independent-bill-module"
	],
	"src/app/employee-layout/employees/sms/sms.module": [
		"./src/app/employee-layout/employees/sms/sms.module.ts",
		"src-app-employee-layout-employees-sms-sms-module"
	],
	"src/app/employee-layout/employees/store/store.module": [
		"./src/app/employee-layout/employees/store/store.module.ts",
		"default~src-app-employee-layout-employees-canteen-canteen-module~src-app-employee-layout-employees-e~7fba699d",
		"common",
		"src-app-employee-layout-employees-store-store-module"
	],
	"src/app/employee-layout/employees/students/student-admission.module": [
		"./src/app/employee-layout/employees/students/student-admission.module.ts",
		"common",
		"src-app-employee-layout-employees-students-student-admission-module"
	],
	"src/app/employee-layout/employees/subjects/subject.module": [
		"./src/app/employee-layout/employees/subjects/subject.module.ts",
		"common",
		"src-app-employee-layout-employees-subjects-subject-module"
	],
	"src/app/employee-layout/employees/users/users.module": [
		"./src/app/employee-layout/employees/users/users.module.ts",
		"default~src-app-employee-layout-employees-canteen-canteen-module~src-app-employee-layout-employees-e~50efbfbb",
		"common",
		"src-app-employee-layout-employees-users-users-module"
	],
	"src/app/guardian-layout/guardian/guardian-student-finance/guardian-student-finance.module": [
		"./src/app/guardian-layout/guardian/guardian-student-finance/guardian-student-finance.module.ts",
		"common",
		"src-app-guardian-layout-guardian-guardian-student-finance-guardian-student-finance-module"
	],
	"src/app/guardian-layout/guardian/result/guardian-result-checker.module": [
		"./src/app/guardian-layout/guardian/result/guardian-result-checker.module.ts",
		"src-app-guardian-layout-guardian-result-guardian-result-checker-module"
	],
	"src/app/student-layout/students/results/student-result-checker.module": [
		"./src/app/student-layout/students/results/student-result-checker.module.ts",
		"src-app-student-layout-students-results-student-result-checker-module"
	],
	"src/app/student-layout/students/student-online-examination/student-online-examination.module": [
		"./src/app/student-layout/students/student-online-examination/student-online-examination.module.ts",
		"default~src-app-student-layout-students-student-online-examination-student-online-examination-module~4412dc20",
		"common",
		"src-app-student-layout-students-student-online-examination-student-online-examination-module"
	],
	"src/app/teacher-layout/teachers/online-examination/online-examination.module": [
		"./src/app/teacher-layout/teachers/online-examination/online-examination.module.ts",
		"default~src-app-employee-layout-employees-canteen-canteen-module~src-app-employee-layout-employees-e~50efbfbb",
		"default~src-app-student-layout-students-student-online-examination-student-online-examination-module~4412dc20",
		"common",
		"src-app-teacher-layout-teachers-online-examination-online-examination-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;